import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as RequestActions from '../../../actions/requestActions';
import ImageLeft from '../../custom/sections/ImageLeft';
import ImageRight from '../../custom/sections/ImageRight';
import aboutContent from '../../../constatns/about';
import './index.css';


class WebApi extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }


  render() {
    const { lang } = this.props;

    return (
      <div className='page-padding'>
        {
          aboutContent.map((item,index)=>{
            if(index%2 === 0){ return <ImageLeft key={item + index} lang={lang} content={item}/>}
            else {return <ImageRight key={item + index} lang={lang} content={item}/>}
          })
        }
      </div>
    );
  }
}


const mapStateToProps = state => ({
  lang: state.request.lang
});


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    ...RequestActions,
  }, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(WebApi);
